import Api from '../../api/index'

const Status = {
  namespaced: true,
  state: {
    value: 'my value',

    oneStatus: null, //to store SHOW response
    allStatuses: null, //to store SHOW response

    //promises results
    createStatusWasGood: null,
    createStatusMessage: null,
    
    updateStatusWasGood: null,
    updateStatusMessage: null,

     // less used
    indexStatusWasGood: null,
    indexStatusMessage: null,

    showStatusWasGood: null,
    showStatusMessage: null,
  },
  getters: {
    getStateValue: state => {
      return state.value;
    }
  },

  mutations: {
    setOneStatus(state, status){
      state.oneStatus = status // status.data
    },
    setAllStatuss(state, statuses){
      state.allStatuses = statuses // statuses.data
    },

    createResponse(state, {was_good, msg}){
      state.createStatusWasGood = was_good
      state.createStatusMessage = msg
      setTimeout(() => {
        state.createStatusWasGood = null
      }, 100);
    },
    updateResponse(state, {was_good, msg}){
      state.updateStatusWasGood = was_good
      state.updateStatusMessage = msg
      setTimeout(() => {
        state.updateStatusWasGood = null
      }, 100);
    },
    indexResponse(state, {was_good, msg}){
      state.indexStatusWasGood = was_good
      state.indexStatusMessage = msg
      setTimeout(() => {
        state.indexStatusWasGood = null
      }, 100);
    },
    showResponse(state, {was_good, msg}){
      state.showStatusWasGood = was_good
      state.showStatusMessage = msg
      setTimeout(() => {
        state.showStatusWasGood = null
      }, 100);
    },

    clearAllStatuss(state){
      state.allStatuses = null
    },
    clearOneStatus(state){
      state.oneStatus = null
    },
  },

  actions: {
    clearAllStatuss({commit}){
      commit('clearAllStatuss')
    },
    clearOneStatus({commit}){
      commit('clearOneStatus')
    },

    index(context, filter) {
      Api.Status.index(filter)
        .then(response => response.data)
        .then(statuses => {
          context.commit('setAllStatuss', statuses);
          context.commit('indexResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('indexResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    show(context, status_id) {
      Api.Status.show(status_id)
        .then(response => response.data)
        .then(status => {
          context.commit('setOneStatus', status);
          context.commit('showResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('showResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    create(context, new_status) {
      Api.Status.create(new_status)
        .then(response => response.data)
        .then(status => {
          // context.commit('setOneStatuss', status); // not often used
          context.commit('createResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('createResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
    update(context, status) {
      Api.Status.update(status)
        .then(response => response.data)
        .then(status => {
          // context.commit('setOneStatus', status); // not often used
          context.commit('updateResponse', {msg: '', was_good: true});
        }).catch(function(error) {
          context.commit('updateResponse', {msg: error.response.data.errors[0], was_good: false});
          console.log(error);
        });
    },
  }

};

export default Status;